"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  sureToDeleteVoiceMail: 'Are you sure you want to delete this voicemail?',
  sureToDeleteFax: 'Are you sure you want to delete this fax?',
  doNotAskAgain: "Don't ask me again"
};
exports["default"] = _default;
//# sourceMappingURL=en-US.js.map
